import { Action, Reducer } from 'redux';

import { PractitionerConsumption } from '../../../models/Entities/Practitioners/PractitionerConsumption';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { PractitionerState, PractitionerUnloadState } from '../../states/PractitionerState';


import {
    PractitionerConsumptionChangeStatusRequestAction,
    PractitionerConsumptionChangeStatusSuccessAction,
    PractitionerConsumptionChangeStatusFailureAction
} from '../../actions/PractitionerConsumption.Actions';

type KnownAction =
    PractitionerConsumptionChangeStatusRequestAction |
    PractitionerConsumptionChangeStatusSuccessAction |
    PractitionerConsumptionChangeStatusFailureAction;

const PractitionerChangeStatusReducer: Reducer<PractitionerState> = (
    state: PractitionerState | undefined,
    incomingAction: Action
): PractitionerState => {

    if (state === undefined) {
        return PractitionerUnloadState as PractitionerState;
    }

    let CurrentPractitioner: Practitioner | undefined = undefined;
    let CurrentConsumption: PractitionerConsumption | undefined = undefined;

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_REQUEST':
            
            CurrentPractitioner = state.list.find((practitioner: Practitioner) => practitioner.userId === action.practitionerId);

            if (CurrentPractitioner) {
                CurrentConsumption = CurrentPractitioner.consumptions?.find((consumption: PractitionerConsumption) => consumption.id === action.consumptionId);
                
                if (CurrentConsumption) {
                    CurrentConsumption.isChangingStatus = true;
                    CurrentConsumption.ChangedStatusSuccess = undefined;
                    CurrentConsumption.failureOnChangeStatus = false;
                    CurrentConsumption.ChangedStatusError = undefined;
                }
            }

            return {
                ...state,
                list: CurrentPractitioner ? [...(state.list ?? []).filter((practitioner: Practitioner) => practitioner.userId !== CurrentPractitioner?.userId), CurrentPractitioner] : [...state.list],
            };

        case 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_SUCCESS':
            CurrentPractitioner = state.list.find((practitioner: Practitioner) => practitioner.userId === action.practitionerId);

            if (CurrentPractitioner) {
                
                CurrentConsumption = CurrentPractitioner.consumptions?.find((consumption: PractitionerConsumption) => consumption.id === action.consumptionId);
                
                if (CurrentConsumption) {
                    CurrentConsumption.isChangingStatus = false;
                    CurrentConsumption.ChangedStatusSuccess = true;
                    CurrentConsumption.failureOnChangeStatus = false;
                    CurrentConsumption.ChangedStatusError = undefined;
                    CurrentConsumption.status = action.status; // Update the status of the consumption
                }
            }

            return {
                ...state,
                list: CurrentPractitioner ? [...(state.list ?? []).filter((practitioner: Practitioner) => practitioner.userId !== CurrentPractitioner?.userId), CurrentPractitioner] : [...state.list],
            };

        case 'PRACTITIONERCONSUMPTION_CHANGE_STATUS_FAILURE':
            CurrentPractitioner = state.list.find((practitioner: Practitioner) => practitioner.userId === action.practitionerId);

            if (CurrentPractitioner) {
                CurrentConsumption = CurrentPractitioner.consumptions?.find((consumption: PractitionerConsumption) => consumption.id === action.consumptionId);
                
                if (CurrentConsumption) {
                    CurrentConsumption.isChangingStatus = false;
                    CurrentConsumption.ChangedStatusSuccess = false;
                    CurrentConsumption.failureOnChangeStatus = true;
                    CurrentConsumption.ChangedStatusError = action.error;
                }
            }

            return {
                ...state,
                list: CurrentPractitioner ? [...(state.list ?? []).filter((practitioner: Practitioner) => practitioner.userId !== CurrentPractitioner?.userId), CurrentPractitioner] : [...state.list],
            };

        default:
            return state;
    }
}

export default PractitionerChangeStatusReducer;


